/** @module AQL/AggregateShipmentsController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/AggregateFrom",
	"csi/xml",
	"csi/xml/Query"
], function(declare,_,AggregateFrom,xml,Query) {

	return declare(AggregateFrom, {
	
		/**
		 * Filter shipments by FinalInspection.ShipmentTerms, if exist.
		 * @param {csi/view/Widget} view - the view the action is on
		 */
		applyActionFilters: function(view) {
			const insp = this.getParent();
			if (insp.ShipmentTerms && insp.ShipmentTerms.length) {
				const q = new Query();
				
				_.each(insp.ShipmentTerms, function(st) {
					this.RefAttr("__Parent__", xml.OP_EQUALS, st);
				}, q.Or());
				
				view.relRoot.addQuery(q);
			}

			this.inherited(arguments);
		}
	});
});